import React from 'react';
import { PictoProps } from './index';

export const Clip = (props: PictoProps) => (
  <svg
    width={props.width || '23'}
    height={props.height || '23'}
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.1634 10.6622L11.9734 19.8522C9.62899 22.1967 5.82788 22.1967 3.48343 19.8522C1.13899 17.5078 1.13899 13.7067 3.48343 11.3622L12.6734 2.17222C14.2364 0.609259 16.7705 0.609259 18.3334 2.17222C19.8964 3.73519 19.8964 6.26926 18.3334 7.83222L9.13343 17.0222C8.35195 17.8037 7.08492 17.8037 6.30343 17.0222C5.52195 16.2407 5.52195 14.9737 6.30343 14.1922L14.7934 5.71222"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
